import React, { useState, useEffect } from 'react'
import { getSrc } from "gatsby-plugin-image"
import LazyLoad from 'react-lazyload';
import Tag from 'antd/lib/tag'

const Card = ({data, hiding, updateFilter, onClick}) => {
  const [ hashTag , setHashTag ] = useState([]);
  
  useEffect(() => {
    let tempHash = [];
    data.replaySessionStyle.split(' ').forEach((item,index) => {
      if(item.replace('#','') != "")
        tempHash.push(item.replace('#',''))
    });
    setHashTag(tempHash);
  },[data])
  
  return (
    <div className={`logItem ${hiding ? "hiding" : "show"}`} onClick={(e) => {
      e.preventDefault();
      onClick(data);
    }}>
      <div className="content">
        <div className="frame">
          <LazyLoad offset={500} once height="100%">
            {data.replayThumbnail !== null ?
              <img src={data.replayThumbnail} /> :
              <img src={require('../../../assets/images/default_thumb.jpg').default} />
            }
          </LazyLoad>
        </div>
        <div className="text">
          <div className="upperTag">
            <Tag className="type" color="#38241c" onClick={(e) => {
              e.stopPropagation();
              updateFilter('format-label',data.replaySessionFormat)
            }}>{data.replaySessionFormat}</Tag>
            <Tag className="system" color="#7f6960" onClick={(e) => {
              e.stopPropagation();
              updateFilter('system-label',data.replaySystemname)
            }}>{data.replaySystemName}</Tag>
          </div>
          <div className="title">
            {data.replayScenarioName}
          </div>
          <div className="nameData">
            <div className="gmName">
              <div className="label">GM:</div>
              <div className="name"><a href="#" onClick={(e) => {
                e.stopPropagation();
                updateFilter('gm-label',data.replayGm)
            }}>{data.replayGm}</a></div>
            </div>
            {data.replayPlayersName !== "" &&
              <div className="playerName">
                <div className="label">參與玩家: </div>
                <div className="name">{data.replayPlayersName}</div>
              </div>
            }
          </div>
          <div className="desc">
            {data.replayScenariodescription}
          </div>
          {(hashTag.length > 0) &&
            <div className="tagList">
              {hashTag.map((item,index) =>(
                <a href="#" onClick={(e) => {
                  e.stopPropagation();
                  updateFilter('tag',[item])
              }}  key={"hashList_" + index}>{'#' + item}</a>
              ))}
            </div>
          }
          <div className="date">
            {'投稿時間：'+data.replayTimestamp}
          </div>
        </div>

      </div>
    </div>
  );
}

export default Card;